import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { FormulaTesterComponent, Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { DialogService } from 'src/app/services/dialog.service';
import { FormServices } from 'src/app/services/form.services';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { FormFieldPropertiesDetailActionsParamsComponent } from '../form-field-properties-detail-actions-params/form-field-properties-detail-actions-params.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'form-field-properties-detail-actions',
    templateUrl: './form-field-properties-detail-actions.component.html',
    styleUrls: ['./form-field-properties-detail-actions.component.scss'],
    standalone: false
})
export class FormFieldPropertiesDetailActionsComponent implements OnInit {

  constructor(private http:HTTPService, private uas:UserAuthenticationServices,
    private fb:UntypedFormBuilder, private fs:FormServices, private snackBar:SnackbarService,
    private dialogServices:DialogService,
    public ThemeService:ThemeService) { }

  @Input() entityName:string;
  //@Input() columnName:string;
  @Input() prefName:string;
  @Input()row:Object;
  editMode = false;
  /** spinner NG-ZORRO (substitui o ngx-spinner 'actionpref') */
  actionLoading = false;
  selectedObject:Object = null;
  data:BehaviorSubject<Object[]> = new BehaviorSubject<Object[]>([]);
  formAction:UntypedFormGroup;
  formula:string;
  sub3:Subscription;
  newMode:boolean = false;
  condition:string ="0=1";
  variables:Variable[] = [];
  @Input()showParameter:boolean = false;

  ngOnDestroy(){
      if (this.sub3 !=null) { this.sub3.unsubscribe()}
  }

  ngOnInit(): void {
      this.loadConfiguration();
      if (this.row!= null ){
        Object.keys(this.row).forEach(data=>{
          if ( this.row[data] != null ){
            if  ( !(this.row[data] instanceof Array)){
              let variable:Variable = {
                key:"@"+data,
                value:String(this.row[data]),
                type:'Texto'
              }
              this.variables.push(variable);
            }
          }
            
        })  
      }
      
      this.formAction = this.fb.group({
        INTERNALID:new UntypedFormControl({value:null,disabled:true}),
        CODECOMPANY:new UntypedFormControl({value:null,disabled:true}),
        CODECONTRACT:new UntypedFormControl({value:null,disabled:true}),
      })

  }

  loadConfiguration(){
    if ( this.entityName != null  && this.prefName !=null ){
      this.actionLoading = true;
      let ob = {
      "entityName":"Mktpcontractpref",
      "sql":`SELECT  CONVERT(VARCHAR(100),B.CODECOMPANY)+' - ' +B.NAME COMPANY,A.CODECOMPANY,A.INTERNALID,A.NAME,A.TEXT, A.CODECONTRACT
            FROM MKTPCONTRACTPREF A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
            WHERE (A.CODECONTRACT IN (${this.uas.getContracts()}) 
            OR A.CODECOMPANY IN (${this.uas.getCompanies()}))
            AND A.NAME= '${this.prefName}'
            ORDER BY 1`
    }
     
    this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
        next:  (data)=>{
            if ( data['SQL']){
              this.data.next(data['SQL'])
            }
            this.actionLoading = false;
        },
        error: (error)=>{
            this.actionLoading = false;
            throw error;
        }
    });

    }
  }

  selectItem(event:Event , item){
    this.editMode = true;
    this.selectedObject = item;
    this.formula = item['TEXT'];
    if ( this.selectedObject != null ){
      this.condition = `CODECONTRACT = ${this.selectedObject['CODECONTRACT']}`;
      this.fs.refreshFormObject(this.formAction,this.selectedObject);
    }
   
  }

  deleteItem(event:Event , item){
    
    this.dialogServices.errorDialoag = false;
    this.dialogServices.openNewDialog("Deseja remover o registro selecionado?",(data)=>{
          
          let remove:Object = {}; 
          remove["entityName"] = "Mktpcontractpref"
          remove["condition"] = "INTERNALID = " + item['INTERNALID'];
  
            this.http.post(remove,"JsonBrokerServices/remove",false).subscribe({
              next:(data)=>{
                this.snackBar.showInformation('Registro excluido com sucesso.');
                this.loadConfiguration();
              },
              error:(error)=>{
                throw error;
              }
            })
    })
  }

  cancelEdit(){
    this.editMode = false;
    this.newMode = true;
    this.selectedObject = null;
    this.formAction.get('INTERNALID').setValue(null);
    this.formAction.get('CODECOMPANY').disable();
    this.formAction.get('CODECOMPANY').setValue(null);
    this.formAction.get('CODECONTRACT').disable();
    this.formAction.get('CODECONTRACT').setValue(null);
    this.formula = null;
  }

  novo(){
      this.editMode = true;
      this.selectedObject = null;
        
      this.newMode = true;
      this.formAction.get('INTERNALID').setValue(null);
      this.formAction.get('CODECOMPANY').enable();
      this.formAction.get('CODECOMPANY').setValue(null);
      this.formAction.get('CODECONTRACT').enable();
      this.formAction.get('CODECONTRACT').setValue(null);
      this.formula = null;

  }

  onChange(evento){
    this.condition = `CODECONTRACT = ${this.formAction.get('CODECONTRACT').value}`;
  }

  duplicate(event,item){
      this.editMode = true;
      this.selectedObject = item;
      if ( this.selectedObject != null ){
        
        this.newMode = true;
        this.formAction.get('INTERNALID').setValue(null);
        this.formAction.get('CODECOMPANY').enable();
        this.formAction.get('CODECONTRACT').enable();
        this.formula = item['TEXT'];

        this.fs.refreshFormObject(this.formAction,this.selectedObject);
      }
      
  }

  salvar(){
    this.actionLoading = true;
    this.formAction.markAllAsTouched();

    if ( this.formAction.invalid ){
      this.formAction.updateValueAndValidity();
      this.actionLoading = false;
      return;
    }


    let jsonSave:Object = {
      "entityName":"Mktpcontractpref",
      "TEXT":this.formula
    }

    if ( !this.newMode ){
      jsonSave["INTERNALID"]= this.selectedObject['INTERNALID'];
    }else{
      jsonSave["CODECOMPANY"]= ObjectUtil.isNotEmpty( this.formAction.get("CODECOMPANY").value )?this.formAction.get("CODECOMPANY").value : 0 ;
      jsonSave["CODECONTRACT"]= this.formAction.get("CODECONTRACT").value;
      jsonSave["NAME"] = `${this.prefName}`;
      jsonSave["DESCRIPTION"]= `Busca ${this.prefName} no ERP`;
      jsonSave["TYPE"]= 'T';
      jsonSave["CODEMKTP"]= '0';
    }
    
    this.sub3 = this.http.post(jsonSave,"JsonBrokerServices/save",true).subscribe({
        next:(sucesso)=>{
            this.snackBar.showSuccess('Fórmula registrada com sucesso.')
            this.editMode = false;
            this.newMode = false;
            this.selectedObject = null;
            this.loadConfiguration();
        },
        error:(error)=>{
            this.editMode = false;
            this.newMode = false;
            this.selectedObject = null;
            throw error;
        }
    });
  }

  openEditFormula(){
    this.variables = [];
    if ( this.formAction.get('CODECOMPANY').value!=null){
      this.variables.push({
          key: "@CODECOMPANY",
          value:String(this.formAction.get('CODECOMPANY').value),
          type:'Texto'
      })
    }

    if ( this.formAction.get('CODECONTRACT').value!=null){
      this.variables.push({
          key: "@CODECONTRACT",
          value:String(this.formAction.get('CODECONTRACT').value),
          type:'Texto'
      })
    }

    this.dialogServices.openGenericDialog(FormulaTesterComponent,{formula:this.formula, variables:this.variables},(f)=>{
        if ( f['formula']){
          this.formula = f['formula'];
        }
        
    },()=>{},'80vh','80vw',false,null,'S','80px');
  }

  showParameters($event,item){
    let ob = {
          prefName:this.prefName, 
          CODECOMPANY: item["CODECOMPANY"], 
          CODECONTRACT: item["CODECONTRACT"]
    };

    this.dialogServices.openGenericDialog(FormFieldPropertiesDetailActionsParamsComponent,ob,(f)=>{
        
        
    },()=>{},'80vh','80vw',false,null,'S','80px');
  }
}
